/**
 * List Schema of MotoristaTransbordo
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {MotoristaTransbordo} from '@/model/resource/MotoristaTransbordo'

/* TODO: review generated schema */
export class ListMotoristaTransbordoSchema extends Schema {
  readonly name = 'ListMotoristaTransbordo'

  readonly fieldSet: FieldSet<MotoristaTransbordo> = {
    motorista: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: schema.model.motorista?.$id,
      },
    }),
    podeReceber: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.podeReceber),
      },
    }),
    podeEntregar: (schema): FieldComponent => ({
      is: Component.Render,
      bind: {
        content: Helper.bool(schema.model.podeEntregar),
      },
    }),
  }
}
